"use client";

import { Drawer } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useTranslations } from "next-intl";

import { Icon } from "../../icons";
import type { QuickAction } from "../../types";
import { cn } from "../../utils/cn";

import { QuickActionsModal } from "./QuickActionsModal";

type FloatingActionButtonProps = {
  actions: QuickAction[];
  locale: string;
};

export function FloatingActionButton({
  actions,
  locale,
}: FloatingActionButtonProps) {
  const [opened, { open, close }] = useDisclosure(false);
  const t = useTranslations();

  if (actions.length === 0) return null;

  return (
    <>
      <button
        type="button"
        onClick={open}
        data-testid="quick-actions-fab"
        className={cn(
          "fixed bottom-6 left-1/2 z-40 -translate-x-1/2",
          "flex h-14 w-14 items-center justify-center rounded-full",
          "bg-primary text-white shadow-shell-lg",
          "transition-all hover:scale-105 hover:shadow-xl",
          "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
        )}
        aria-label={t("quick-actions.title")}
      >
        <Icon name="plus" size={24} color="white" />
      </button>

      <Drawer
        opened={opened}
        onClose={close}
        position="bottom"
        size="50%"
        radius="lg"
        title={t("quick-actions.title")}
        styles={{
          title: { fontWeight: 600 },
        }}
      >
        <QuickActionsModal actions={actions} locale={locale} onClose={close} />
      </Drawer>
    </>
  );
}
